module.exports = __webpack_public_path__ + "img/guide-2.8f6db0dc.png";